import { configureStore } from "@reduxjs/toolkit";

import { APP_ENV } from "./Constants/common";
import { loadState, saveState } from "./localStorage";
import rootReducer from "./reducers";

const savedState = loadState();

// On reload, sync clientUserAllPermissions from session.allPermissions if it's missing
let initialState = savedState;
if (initialState?.session) {
  const sessionPerms = initialState.session?.session?.allPermissions;
  if (sessionPerms && !initialState.session.clientUserAllPermissions) {
    let perms = sessionPerms;
    if (perms.is_admin == 1) {
      const fullAccess = {};
      Object.keys(perms).forEach((k) => {
        fullAccess[k] = 1;
      });
      perms = fullAccess;
    }
    initialState = {
      ...initialState,
      session: { ...initialState.session, clientUserAllPermissions: perms },
    };
  }
  // Exclude socket from preloadedState — socket.io instances can't be serialized
  // Exclude page-specific slices so they always start from their reducer's initialState
  const pageLevelSlices = [
    "socket",
    "clientCandidateDetail",
    "clientRoles",
    "clientCandidates",
  ];
  pageLevelSlices.forEach((key) => {
    if (initialState[key] !== undefined) {
      initialState = { ...initialState, [key]: undefined };
    }
  });
}

const environments = ["local", "development", "staging"];

const showDevTools = environments.includes(APP_ENV);

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  preloadedState: initialState,
  devTools: showDevTools,
});

let tempState = {};
if (initialState) {
  tempState = initialState;
}

store.subscribe(() => {
  if (tempState !== store.getState()) {
    saveState(store.getState());
  } else {
    tempState = store.getState();
  }
});

export default store;
